import {
  GET_CUSTOMER_INQUIRY_LIST_REQUEST,
  GET_CUSTOMER_INQUIRY_LIST_SUCCESS,
  GET_CUSTOMER_INQUIRY_LIST_FAILURE
} from "actions/CustomerInquiry/customerInquiryAction";

const initialState = {
  customerInquiryList: [],
  customerInquiryData: {},
};

export default function customerInquiryReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case GET_CUSTOMER_INQUIRY_LIST_REQUEST:
      return {
        ...state
      };
    case GET_CUSTOMER_INQUIRY_LIST_SUCCESS:
      return {
        ...state,
        customerInquiryList: action.payload
      };
    case GET_CUSTOMER_INQUIRY_LIST_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    case 'CUSTOMERINQUIRYDATA':
      if (!action.payload) {
        return initialState;
      } else {
        return {
          ...state,
          customerInquiryData: action.payload
        };
      }

    default:
      return state;
  }
}